const TIME_ZONE = 'America/Sao_Paulo';

/**
 * Idade hoje (fuso de Brasília) a partir de `YYYY-MM-DD` — mesma regra de `ageFrom` do site
 * (`site/src/config/enlistment.ts`), calculada no servidor pra decidir quais termos a inscrição aceita.
 */
export function ageFrom(birthday: string, today = new Date()) {
  const [year, month, day] = birthday.split('-').map(Number);
  if (!year || !month || !day) return null;

  const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: TIME_ZONE })
    .format(today)
    .split('-')
    .map(Number) as [number, number, number];

  let age = y - year;
  if (m < month || (m === month && d < day)) age--;
  return age;
}

export const isMinor = (birthday: string) => {
  const age = ageFrom(birthday);
  return age !== null && age < 18;
};
